// export class Replay {}

// export const InternalReplay = () => {};
// export const internalGetReplay = () => {};
// export const internalReplayIntegration = () => {};
export const replayCanvasIntegration = () => {};

export class Feedback {}
export const buildFeedbackIntegration = () => {};
export const feedbackModalIntegration = () => {};
export const feedbackScreenshotIntegration = () => {};
export const getFeedback = () => {};
export const sendFeedback = () => {};
export const getReplay = () => {};
export const replayIntegration = () => {};
